export default __webpack_public_path__ + "images/QA.27b6cba.png";